import SimpleVueValidation from 'simple-vue-validator';
import VueCookies from 'vue-cookies';
import RefAppVuePaginate from '@refapp/vue-paginate';
import VueScrollTo from 'vue-scrollto';

import RfpRatingsTitleSection from './components/widget/rfp-ratings-title-section/rfp-ratings-title-section.vue';
import RfpRatingsWriteReview from './components/widget/rfp-ratings-write-review/rfp-ratings-write-review.vue';
import RfpRatingsRatingSnapshot from './components/widget/rfp-ratings-rating-snapshot/rfp-ratings-rating-snapshot.vue';
import RfpRatingsWriteReviewSuccess from './components/widget/rfp-ratings-write-review-success/rfp-ratings-write-review-success.vue';
import RfpRatingsWriteReviewWarning from './components/widget/rfp-ratings-write-review-warning/rfp-ratings-write-review-warning.vue';
import RfpRatingsAverageCustomerRatings from './components/widget/rfp-ratings-average-customer-ratings/rfp-ratings-average-customer-ratings.vue';
import RfpRatingsMostHelpfulFavorableReview from './components/widget/rfp-ratings-most-helpful-fav-review/Plugins/rfp-ratings-most-helpful-fav-review.vue';
import RfpRatingsMostHelpfulCriticalReview from './components/widget/rfp-ratings-most-helpful-critical-review/rfp-ratings-most-helpful-critical-review.vue';
import RfpRatingsList from './components/widget/rfp-ratings-list/Plugins/rfp-ratings-list.vue';
import RfpRatingsStarRatingProduct from './components/widget/rfp-ratings-star-rating-product/rfp-ratings-star-rating-product.vue';
import RfpRatingsAlreadySubmited from './components/widget/rfp-ratings-already-submited/rfp-ratings-already-submited.vue';
import RfpRatingsTags from './components/widget/rfp-ratings-tags/rfp-ratings-tags.vue';
import RfpRatingsTaggingBrand from './components/widget/rfp-ratings-tags/rfp-ratings-tagging-brand.vue';
import RfpRatingsWriteReviewAutoView from './components/widget/rfp-ratings-write-review/rfp-ratings-write-review-auto-view.vue';
import RfpCommonLoading from './components/widget/rfp-ratings-loading-overlay/js/rfp-ratings-loading-overlay.vue';

import './styles/entry.scss';

// Install the components
export default {
  install(app) {
    const components = [
      RfpRatingsTitleSection,
      RfpRatingsWriteReview,
      RfpRatingsRatingSnapshot,
      RfpRatingsWriteReviewSuccess,
      RfpRatingsWriteReviewWarning,
      RfpRatingsAverageCustomerRatings,
      RfpRatingsMostHelpfulFavorableReview,
      RfpRatingsMostHelpfulCriticalReview,
      RfpRatingsList,
      RfpRatingsStarRatingProduct,
      RfpRatingsAlreadySubmited,
      RfpRatingsTags,
      RfpRatingsTaggingBrand,
      RfpRatingsWriteReviewAutoView,
      RfpCommonLoading,
    ];

    app.use(SimpleVueValidation);
    app.use(RefAppVuePaginate);
    app.use(VueScrollTo);

    if (!app.$cookies) app.use(VueCookies);

    components.forEach((c) => app.component(c.name, c));
  },
};
